// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

function registerValidSW(swUrl, config) {
  let refreshing;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    console.info('Reload 2');
    window.location.reload();
  });

  navigator.serviceWorker
    .register(swUrl, { updateViaCache: 'none' })
    .then(async registration => {
      const myWorker =
        registration.installing || registration.waiting || registration.active;

      if (
        (myWorker?.state === 'activated' || myWorker?.state === 'activating') &&
        !navigator.serviceWorker.controller?.state
      ) {
        await registration.unregister().then(() => {
          // console.info('registerValidSW 1');
          registerValidSW(swUrl, config);
        });
      }

      // eslint-disable-next-line no-param-reassign
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            console.info('SW installed');
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              // New content is available and will be used when all
              // tabs for this page are closed. See https://cra.link/PWA.

              // Execute callback
              if (config && config.onUpdate) config.onUpdate(registration);

              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              // Execute callback
            } else if (config && config.onSuccess)
              config.onSuccess(registration);
          }
        };
      };
    })
    .catch(async error => {
      console.error('Error during service worker registration:', error);
      // Handle chunk file fetch errors
      if (error.message.includes('chunk')) {
        console.warn('Problem with chunk files, clearing cache...');

        // Delete chunk file cache
        const cacheName = 'chunk-files';
        const cache = await caches.open(cacheName);
        const cacheKeys = await cache.keys();

        // Clear the cache
        await Promise.all(cacheKeys.map(request => cache.delete(request)));

        // Reload the page to fetch the chunk files again
        console.info('reload after clear catch');
        window.location.reload();
      }
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            console.info('Reload 3');
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        // console.info('registerValidSW 2');

        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.error(
        'No internet connection found. App is running in offline mode.',
      );
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}

export function register(config) {
  if (!isLocalhost && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    const registerAfterLoad = () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.info(
            'This web app is being served cache-first by a service worker.',
          );
        });
      } else {
        // Is not localhost. Just register service worker
        const regFcmMsg = localStorage.getItem('reg-fcm');
        // console.info(`*** regFcmMsg:${regFcmMsg} `);
        if (!regFcmMsg) {
          console.info('registerValidSW 3');
          registerValidSW(swUrl, config);
        }
      }
    };

    if (document.readyState === 'complete' || document.readyState !== 'loading')
      registerAfterLoad();
    else window.addEventListener('load', registerAfterLoad);
  }
}

export const manualUpdate = async ({ callback }) => {
  // Check if service workers are supported by the browser
  if ('serviceWorker' in navigator) {
    try {
      // Wait for the service worker to become ready
      // const registration = await navigator.serviceWorker.ready;
      const registration = await Promise.race([
        navigator.serviceWorker.ready,
        new Promise((_, reject) => {
          setTimeout(() => {
            reject(new Error('Service worker ready timeout'));
          }, 8000); // 8-second timeout
        }),
      ]);

      const unregisterPromises = [];

      // Unregister all existing service workers
      if (registration) {
        // unregisterPromises.push(registration.unregister());
        unregisterPromises.concat([registration.unregister()]);
      }

      // Get all caches and delete them
      const allCaches = await caches.keys();
      const cacheDeletionPromises = allCaches.map(cache =>
        caches.delete(cache),
      );

      // Wait for all unregister and cache deletion operations to complete
      await Promise.all([...unregisterPromises, ...cacheDeletionPromises]);

      // Check if the service worker controller exists
      if (navigator.serviceWorker.controller) {
        // Post a message to the service worker controller to activate clients
        navigator.serviceWorker.controller.postMessage({
          type: 'CLIENTS_ACTIVATION',
        });

        // Reload the page to apply the changes
        window.location.reload(true);
      } else {
        console.warn('No service worker controller found.');
        // Call the callback after successful completion
        callback('no_service_worker');
      }
    } catch (error) {
      // Handle errors by logging them and invoking the callback
      console.error('Error during manual update:', error.message);
      callback();
    }
  } else {
    console.warn('Service workers are not supported in this browser.');
    callback(); // Ensure callback is called even if service workers are not supported
  }
};
